import React from 'react';
import './Gallery.css';

const Gallery = () => {
  const galleryImages = [
    { caption: "Interactive Learning Sessions", emoji: "📚" },
    { caption: "Science Laboratory Experiments", emoji: "🔬" },
    { caption: "Mathematics Workshop", emoji: "📐" },
    { caption: "Award Ceremony Celebrations", emoji: "🏆" },
    { caption: "Student Activities & Events", emoji: "🎨" },
    { caption: "Computer Lab Sessions", emoji: "💻" },
    { caption: "Library & Reading Corner", emoji: "📖" },
    { caption: "Sports & Extra-curricular", emoji: "⚽" },
    { caption: "Annual Day Celebrations", emoji: "🎭" }
  ];

  return (
    <section id="gallery" style={{ background: 'var(--light-grey)' }}>
      <div className="section-header">
        <h2 className="section-title">Campus Life & Facilities</h2>
        <p className="section-subtitle">
          Explore our vibrant learning environment and state-of-the-art facilities
        </p>
      </div>
      <div className="gallery-grid">
        {galleryImages.map((image, index) => (
          <div key={index} className="gallery-item">
            <div className="image-placeholder">{image.emoji}</div>
            <div className="gallery-overlay">
              <div className="gallery-caption">{image.caption}</div>
            </div>
          </div>
        ))}
      </div>
      <p style={{ textAlign: 'center', marginTop: '2rem', opacity: 0.7 }}>
        * Replace placeholder emojis with actual photos of your academy
      </p>
    </section>
  );
};

export default Gallery;
